/**
 * Static decoration marks for ::define syntax (L2 mode).
 */

import { Decoration } from "@codemirror/view";

export const defineHeadMark = Decoration.mark({ class: "cm-magic-define-head" });
export const defineCloseMark = Decoration.mark({ class: "cm-magic-define-close" });
